import { css } from '@fable/theme'
import {
  AppreciationPosts,
  HomeFeatures,
  HomeFeaturesContainer,
  HomeHero,
  StarSpinner,
} from './components'
import { useHomeBgColor } from './lib/hooks'
import { HomeFeaturesKey } from './lib/types'
import { homeFeaturesMap } from './lib/constants'

const HomePage = () => {
  const {
    bgColor,
    discoverRef,
    discussRef,
    appreciationPostsRef,
    organizeRef,
  } = useHomeBgColor()

  const assignRef = (id: HomeFeaturesKey) => {
    switch (id) {
      case 'discover':
        return discoverRef
      case 'discuss':
        return discussRef
      case 'organize':
        return organizeRef
      default:
        return null
    }
  }

  return (
    <div
      className={css`
        overflow: hidden;
      `}
    >
      <HomeHero
        title="Bookworms and binge-watchers"
        description="Join a community of good people to discuss great stories on Fable."
        label="Welcome home"
        imagesTopId="7Bymb1hOoJOaXhQNuyNK4g"
        imagesBottomId="5Hlsr1l9IkwE9IEnrRQUMK"
      />
      <HomeFeaturesContainer backgroundColor={bgColor}>
        {homeFeaturesMap.map((feature, i) => (
          <HomeFeatures key={i} ref={assignRef(feature.id)} {...feature} />
        ))}
      </HomeFeaturesContainer>
      <StarSpinner />
      <AppreciationPosts ref={appreciationPostsRef} />
    </div>
  )
}

export default HomePage
